import React from "react";
import type { FC } from "react";
import { useTranslation } from "@edreamsodigeo/frontend-core";
import { Box, Flex, Money, Body } from "@edreamsodigeo/prisma-design-system";

import ContinueButton from "../../../common/ContinueButton/ContinueButton";
import type { PrimePriceSelectionBoxProps } from "../../contract";
import { useTrackingContext } from "../../PriceSelectionBoxTrackingProvider";
import PromotionBadge from "./PromotionBadge";

const PrimePriceSelectionBox: FC<PrimePriceSelectionBoxProps> = ({
  onContinueWithFlight,
  nonDiscountedPrice,
  discountedPrice,
}) => {
  const { t } = useTranslation();
  const { trackOnContinueButtonClick } = useTrackingContext();

  const handleContinueButtonClick = (): void => {
    trackOnContinueButtonClick({ wasSelectedPrimePrice: true });
    onContinueWithFlight();
  };

  return (
    <Flex
      justifyContent={"space-between"}
      backgroundColor={"primary.20"}
      data-testid={"primePriceSelectionBox"}
      alignItems={"center"}
      width={"100%"}
      gap={"2"}
      px={"4"}
      py={"3"}
    >
      <Flex flexDirection={"column"} width={"65%"}>
        <Box>
          <PromotionBadge
            nonDiscountedPrice={nonDiscountedPrice}
            discountedPrice={discountedPrice}
          />
        </Box>
        <Flex alignItems={"flex-end"} gap={"2"} mt={"1"}>
          <Money size={"small"} rounded currency={discountedPrice.currency}>
            {discountedPrice.amount}
          </Money>
          <Money
            strikeThrough={"default"}
            size={"tiny"}
            rounded
            currency={nonDiscountedPrice.currency}
          >
            {nonDiscountedPrice.amount}
          </Money>
        </Flex>
        <Body type={"xSmall"} color={"neutral.80"}>
          {t("equalProminence.primePrice.priceDescription")}
        </Body>
      </Flex>
      <Flex flexDirection={"column"} width={"35%"}>
        <ContinueButton
          onClick={handleContinueButtonClick}
          buttonText={t("equalProminence.continueBtn")}
        />
      </Flex>
    </Flex>
  );
};

export default PrimePriceSelectionBox;
